import { NgModule } from '@angular/core';
import { ShopsModule } from '@luggagehero/web/features/shops';

@NgModule({
  imports: [ShopsModule],
})
export class ShopsLoaderModule {}
